import { render, staticRenderFns } from "./TakeFaceManual.vue?vue&type=template&id=30e82922&"
import script from "./TakeFaceManual.vue?vue&type=script&lang=js&"
export * from "./TakeFaceManual.vue?vue&type=script&lang=js&"
import style0 from "./TakeFaceManual.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TakeFaceManual.vue"
export default component.exports